import { StatsInfo } from "src/components/compounds/GameStats/stat-info-type";
import { eventDateFormatter, fourDigitNumberFormatter } from "../formatters";
import { GridItem, PlayerWithLinkColumn } from "../common-columns";

export interface FieldingStandardFormattedRow {
  player: {
    id: string;
    teamID: string;
    name: string;
    status: string;
  };
  TC: number;
  A: number;
  PO: number;
  FPCT: number;
  E: number;
  DP: number;
}

export const fieldingGridDataFormatted = (grid: GridItem[]): FieldingStandardFormattedRow[] => {
  return grid
    .filter(({ defense }) => defense !== undefined)
    .map(({ person_id, team_id, name, eventID, date, defense }) => {
      return {
        player: {
          id: person_id,
          teamID: team_id,
          name,
          eventID,
          status: "active",
        },
        // Read by the per-game Date column; undefined (and ignored) in season/box-score views.
        event: date,
        TC: defense?.tc ?? 0,
        A: defense?.a ?? 0,
        PO: defense?.po ?? 0,
        FPCT: defense?.fpct ?? 0,
        E: defense?.e ?? 0,
        DP: defense?.dp ?? 0,
      };
    });
};

const CoreFieldingStandard = (sortOnFieldingPercentage: boolean): StatsInfo[] => {
  return [
    { name: "TC", field: "TC", def: "Total Chances" },
    { name: "A", field: "A", def: "Assists" },
    { name: "PO", field: "PO", def: "Putouts" },
    {
      name: "FPCT",
      field: "FPCT",
      def: "Fielding Percentage",
      valueFormatter: fourDigitNumberFormatter,
      sort: "desc",
    },
    { name: "E", field: "E", def: "Errors" },
    { name: "DP", field: "DP", def: "Double Plays" },
  ];
};

export const FieldingStandard: StatsInfo[] = [PlayerWithLinkColumn, ...CoreFieldingStandard(true)];

export const EventFieldingStandard: StatsInfo[] = [
  {
    name: "Date",
    field: "event",
    valueFormatter: eventDateFormatter,
    columnProps: {
      width: 100,
      pinned: true,
      cellStyle: { textAlign: "left" },
      sort: "asc",
    },
  },
  {
    name: "OPPONENT",
    field: "opponent",
    columnProps: {
      width: 260,
      cellStyle: { textAlign: "left" },
      headerClass: "left-aligned-column-header",
    },
  } as StatsInfo,
  ...CoreFieldingStandard(false),
];

export const GameFieldingStandard: StatsInfo[] = [PlayerWithLinkColumn, ...CoreFieldingStandard(true)];
